import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { GuideCard } from '../components/Cards';
import { GUIDES } from '../data/site';
export function BuyingGuides() {
  return <>
      <PageHeader eyebrow="Buying Guides" title="Independent buying guides for an independent home" intro="Not generic lists — structured, evidence-led guidance to help you choose with confidence." data-id="element-235" />

      <div className="max-w-editorial mx-auto px-6" data-id="element-236">
        <div className="flex items-start gap-3 bg-trust-50 border border-trust-200 rounded-sm px-5 py-4 text-sm text-trust-800" data-id="element-237">
          <ShieldCheckIcon className="h-5 w-5 shrink-0 mt-0.5 text-trust-600" data-id="element-238" />
          <p data-id="element-239">
            Each guide has been independently prepared under the{' '}
            <span className="font-600" data-id="element-240">Agreexa Trust Framework®</span>.
          </p>
        </div>
      </div>

      <section className="max-w-editorial mx-auto px-6 py-14" data-id="element-241">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-242">
          {GUIDES.map(g => <GuideCard key={g.slug} guide={g} data-id="element-243" />)}
        </div>
      </section>
    </>;
}